module.exports = __webpack_public_path__ + "static/media/ic_zoom_out_map_black_18px.96a7993e.svg";